import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/utils';
import {
  fieldControlClassName,
  fieldDensityClassName,
  type FieldDensity,
  type FieldControlSize,
} from './input';

/** Retains native option, keyboard and FormData behaviour with shared field geometry. */
export const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> & {
    density?: FieldDensity;
    size?: FieldControlSize;
  }
>(function NativeSelect({ className, density, size, children, ...props }, ref) {
  return (
    <span className="relative inline-flex min-w-0 items-center">
      <select
        {...props}
        ref={ref}
        className={cn(
          fieldControlClassName,
          fieldDensityClassName(density, size),
          'appearance-none pr-8',
          className,
        )}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-2 size-4 text-text-muted"
      />
    </span>
  );
});
